import React from 'react';
import { useNavigate } from 'react-router-dom';
import { PrimaryBtn } from '../Assets/Buttons';
import { CheckIcon } from '@heroicons/react/20/solid';

const GetStarted = () => {
    const navigate = useNavigate();

    // Free tier features
    const freeFeatures = [
        "All Upcoming Games",
        "ML / Spread / Totals with line movement",
        "Team Season Stat Averages",
        "Injury Reports & Lineups",
        "Player Stats",
        "10 Player Analysis sessions / day",
        "5 Game Analysis sessions / day",
        "5 Private Betting Systems / league",
        "Limited Game / Player Analytics Views"
    ];

    return (
        <div className="bg-white dark:bg-brand-dark-900 py-12 sm:py-12 h-full overflow-y-auto">
            <div className="mx-auto max-w-7xl px-6 lg:px-8">
                <div className="mx-auto max-w-2xl text-center">
                    <div className="inline-flex items-center justify-center rounded-full bg-brand-red-500 px-3 py-1 mb-6">
                        <span className="text-xs font-semibold text-white">FREE TIER</span>
                    </div>
                    <h2 className="text-4xl font-bold tracking-tight text-gray-900 dark:text-white sm:text-5xl">
                        Start Betting Smarter Today
                    </h2>
                    <p className="mt-4 text-lg text-gray-600 dark:text-gray-400">
                        Get started with our free tier. No credit card required.
                    </p>
                    <div className="mt-6">
                        <p className="text-5xl font-bold text-gray-900 dark:text-white">
                            $0
                            <span className="text-xl font-normal text-gray-600 dark:text-gray-400">/forever</span>
                        </p>
                    </div>
                </div>

                {/* Features Card */}
                <div className="mx-auto mt-16 max-w-2xl">
                    <div className="rounded-2xl bg-gray-50 dark:bg-brand-dark-800 p-8 shadow-sm ring-1 ring-gray-200 dark:ring-brand-dark-700">
                        <p className="text-sm font-semibold text-gray-900 dark:text-white mb-6">
                            What's included:
                        </p>
                        <ul role="list" className="space-y-4">
                            {freeFeatures.map((feature, index) => (
                                <li key={index} className="flex gap-x-3 items-start">
                                    <CheckIcon 
                                        aria-hidden="true" 
                                        className="h-6 w-5 flex-none text-brand-red-500" 
                                    />
                                    <span className="text-sm text-gray-600 dark:text-gray-300">
                                        {feature}
                                    </span>
                                </li>
                            ))}
                        </ul>

                        {/* Create Account Button */}
                        <div className="mt-8 pt-6 border-t border-gray-200 dark:border-brand-dark-700">
                            <PrimaryBtn 
                                onClick={() => navigate('/signup')}
                                className="w-full"
                            >
                                Create Account
                            </PrimaryBtn>
                        </div>

                        {/* Upgrade Message */}
                        <div className="mt-6 text-center">
                            <p className="text-xs text-gray-500 dark:text-gray-400">
                                Need more? <a href="/pricing" className="font-semibold text-brand-red-500 hover:text-brand-red-600">
                                    Upgrade to Pro
                                </a> for unlimited access to all features.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default GetStarted;

